<template>
  <div>
    <NavBar />
    <div
      class="max-w-[1600px] mx-auto flex flex-col lg:flex-row lg:gap-8 px-4 sm:px-6 lg:px-10 pt-20 sm:pt-24 pb-12"
    >
      <MenuLeft />
      <main class="w-full lg:flex-1 min-w-0">
        <!-- First-login welcome: invite the user to replace their temp password -->
        <div
          v-if="showWelcome"
          class="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 p-4 sm:p-5 mb-6 rounded-2xl bg-brand-50 border border-brand-100"
        >
          <span
            class="w-10 h-10 rounded-xl bg-brand-600 text-white flex items-center justify-center text-lg flex-shrink-0"
          >
            <font-awesome-icon icon="key" />
          </span>
          <div class="flex-1 min-w-0">
            <p class="font-bold text-ink">Welcome to the DBI Research-App 👋</p>
            <p class="text-sm text-ink-soft">
              You're signed in with a temporary password set by your
              administrator. Please choose your own password to secure your
              account.
            </p>
          </div>
          <div class="flex items-center gap-2 flex-shrink-0">
            <router-link
              class="btn btn-primary btn-sm"
              :to="{ name: 'Settings' }"
            >
              Set new password
            </router-link>
            <button
              class="btn btn-ghost btn-sm"
              title="Dismiss for now"
              @click="dismissed = true"
            >
              <font-awesome-icon icon="times" />
            </button>
          </div>
        </div>

        <slot></slot>
      </main>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getterTypes } from 'store/auth'

/**
 * @group TEMPLATES
 * Default template with app nav bar
 */
export default {
  components: {},
  props: {},
  data() {
    return { dismissed: false }
  },
  computed: {
    ...mapGetters({ mustChangePassword: getterTypes.mustChangePassword }),
    showWelcome() {
      // Hide on the Settings page itself (that's where they change it) and
      // once they've dismissed it for the session.
      return (
        this.mustChangePassword &&
        !this.dismissed &&
        this.$route.name !== 'Settings'
      )
    },
  },
}
</script>
